import api from "./api";

export const SensorUnitsService = {
  getAll: async () => {
    const { data } = await api.get("/v1/sensor-units");
    return data;
  },
  getById: async (id) => {
    const { data } = await api.get(`/v1/sensor-units/${id}`);
    return data;
  },
  getByImei: async (imei) => {
    const { data } = await api.get(`/v1/sensor-units/imei/${imei}`);
    return data;
  },
  create: async (payload) => {
    const { data } = await api.post("/v1/sensor-units", payload);
    return data;
  },
  update: async (id, payload) => {
    const { data } = await api.put(`/v1/sensor-units/${id}`, payload);
    return data;
  },
  delete: async (id) => {
    const { data } = await api.delete(`/v1/sensor-units/${id}`);
    return data;
  },
};
